import React from 'react';
import { Route, Routes } from 'react-router-dom';
import routes from 'store/configs/Routes';

import MyStandardsBallotsComponent from './standardsBallotsPages/MyStandardsBallotsComponent';
import AllStandardsBallotsComponent from './standardsBallotsPages/AllStandardsBallotsComponent';
import StandardsBallotContextProvider from './StandardsBallotContext';
import StandardsBallotsFormCardComponent from './standardsBallotsPages/StandardsBallotsFormCardComponent';

const StandardsBallotRoutes: React.FunctionComponent = () => {
  return (
    <StandardsBallotContextProvider>
      <div id="standardsBallotsComponent">
        <Routes>
          <Route
            path={routes.standardsBallot.myBallots + '/*'}
            element={
              <Routes>
                <Route index element={<MyStandardsBallotsComponent />} />
                <Route path={routes.standardsBallot.voting} element={<StandardsBallotsFormCardComponent />} />
              </Routes>
            }
          />
          <Route path="*" element={<AllStandardsBallotsComponent />} />
        </Routes>
      </div>
    </StandardsBallotContextProvider>
  );
};

export default StandardsBallotRoutes;
